import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconUsers: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66667 6.72222C7.38489 6.72222 8.77778 5.32933 8.77778 3.61111C8.77778 1.89289 7.38489 0.5 5.66667 0.5C3.94845 0.5 2.55556 1.89289 2.55556 3.61111C2.55556 5.32933 3.94845 6.72222 5.66667 6.72222ZM11.8889 8.2778C13.1776 8.2778 14.2222 7.23313 14.2222 5.94447C14.2222 4.65581 13.1776 3.61113 11.8889 3.61113C10.6002 3.61113 9.55556 4.65581 9.55556 5.94447C9.55556 7.23313 10.6002 8.2778 11.8889 8.2778ZM15.7778 12.9445C15.7778 13.374 15.4296 13.7222 15 13.7222H11.1111C11.1111 14.1518 10.7629 14.5 10.3333 14.5H1.00001C0.570452 14.5 0.222229 14.1518 0.222229 13.7222C0.224158 12.2845 0.794697 10.9059 1.80934 9.88725C3.93137 7.75691 7.37859 7.75015 9.50893 9.87218C10.1894 9.34564 11.0252 9.05961 11.8856 9.05888C14.0334 9.05707 15.776 10.7967 15.7778 12.9445Z"
      />
    </svg>
  </IconStyled>
);

IconUsers.defaultProps = iconDefaultProps;
IconUsers.displayName = 'IconUsers';

export default IconUsers;
